import React, { useState, useEffect, useRef } from 'react';
import Layout from '../Layout/Layout.js';
import { APIUrl } from '../../Helper/APIUrl.js';
import { SnackbarProvider, useSnackbar } from "notistack";
import DataTable from 'react-data-table-component';
import { Button } from 'react-bootstrap';

function ManageNewsLetter() {
  const Token = JSON.parse(localStorage.getItem('tcn'));
  const { enqueueSnackbar } = useSnackbar();

  const [search, setsearch] = useState("");
  const [newsletters, setNewsletters] = useState([]);
  const [filterNewsletters, setFilterNewsletters] = useState([]);

  const parseJSON = async (response) => {
    try {
      if (response.status === 204 || response.status === 205) return null;
      const text = await response.text();
      if (!text) return null;
      return JSON.parse(text);
    }
    catch (err) {
      console.warn('Failed to parse JSON response', err);
      return null;
    }
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return '';
    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString('en-US', { month: 'short' });
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }

  const ConcateURL = APIUrl.NewsLetter || (APIUrl.BaseUrl + '/NewsLetter/');

  const getAllNewsLetters = async () => {
    try {
      const response = await fetch(ConcateURL + 'GetAllNewsLetter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Token}`
        },
        body: JSON.stringify({})
      });

      const result = await parseJSON(response);
      if (result && result.data != null) {
        setNewsletters(result.data);
        setFilterNewsletters(result.data);
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  useEffect(() => { getAllNewsLetters(); }, []);

  useEffect(() => {
    const term = search.trim().toLowerCase();
    if (!term) {
      setFilterNewsletters(newsletters);
      return;
    }

    const result = newsletters.filter(x =>
      (x.Email || '').toLowerCase().includes(term) ||
      (x.Name || '').toLowerCase().includes(term) ||
      (x.CreatedOn || '').toLowerCase().includes(term)
    );

    setFilterNewsletters(result);
  }, [search, newsletters]);

  const columns = [
    { name: <strong>SNo.</strong>, selector: (row, i) => i + 1, width: '80px' },
    { name: <strong>Id</strong>, selector: (row) => row.NewsLetterId || row.Id || '' },
    { name: <strong>Subscription Email</strong>, selector: (row) => (<div className="flex flex-col gap-1"><span className="font-semibold text-sm">{row.Name}</span><span className="text-xs text-gray-500">{row.Email}</span></div>), grow: 2 },
    { name: <strong>Created On</strong>, selector: (row) => formatDate(row.CreatedOn), sortable: true },
    { name: <strong>Status</strong>, selector: (row) => row.IsActive ? <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Active</label> : <label className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">Inactive</label>, width: '160px' }
  ];

  return (
    <div>
      <Layout>
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Manage Newsletters</h2>
                <div className="mb-4">
                  <input
                    type="text"
                    placeholder="Search by name or email"
                    value={search}
                    onChange={(e) => setsearch(e.target.value)}
                    className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-lg"
                  />
                </div>
                <DataTable
                  columns={columns}
                  data={filterNewsletters}
                  pagination
                  fixedHeader
                  fixedHeaderScrollHeight="550px"
                  selectableRows
                  selectableRowsHighlight
                  highlightOnHover
                />
              </div>
            </div>
          </div>
        </main>
      </Layout>
    </div>
  )
}

export default ManageNewsLetter;
